import React from "react";
import { Container, Row, Col } from "reactstrap";
import { ChevronsRight, Circle } from "react-feather";

const PRIMARY_TEXT_COLOR = "#000"; // Adjust based on your theme

const TermsAndConditions = () => {
  const bullet = (
    <strong className="pr-2">
      <Circle size={6} fill={PRIMARY_TEXT_COLOR} />
    </strong>
  );
  const subbullet = (
    <strong className="pr-2">
      <ChevronsRight size={16} fill={PRIMARY_TEXT_COLOR} />
    </strong>
  );

  const JobListStyles = () => (
    <style>{`
      li {
        margin-bottom: 6px;
        line-height: 1.6;
      }
      ul, ol {
        padding-left: 1rem;
      }
    `}</style>
  );

  return (
    <Container
      fluid
      className="mt-5 py-5 px-3 px-md-5"
      style={{ color: "rgb(71, 77, 106)" }}
    >
      <Row className="justify-content-center">
        <JobListStyles />
        <Col xs={12} md={10} lg={8}>
          <div className="py-4 px-2 d-flex justify-content-center">
            <h5 className="headingMainStyle">
              <span>Terms & Conditions</span>
            </h5>
          </div>
          <p className="mb-4" style={{ color: "rgb(71, 77, 106)" }}>
            Welcome to <strong>BetelJobs</strong>. By registering as a candidate
            on our platform, you agree to comply with and be bound by the
            following Terms and Conditions. Please read them carefully before
            proceeding.
          </p>

          <ol>
            <li>
              <strong>Agreement to Terms</strong>
              <ul>
                <li>
                  {bullet} By registering on BetelJobs, you agree to be bound by
                  these Terms and Conditions.
                </li>
                <li>{bullet} If you do not agree, do not register or use the Portal.</li>
              </ul>
            </li>

            <li>
              <strong>Use of the Portal</strong>
              <ul>
                <li>
                  <strong>{subbullet} Candidate Responsibilities:</strong>
                  <ul>
                    <li>{bullet} Provide accurate and up-to-date information in your profile.</li>
                    <li>{bullet} Use the Portal only for legitimate job search purposes.</li>
                    <li>{bullet} Comply with all applicable laws and regulations.</li>
                    <li>{bullet} Refrain from harmful, offensive, or disruptive conduct.</li>
                    <li>{bullet} Avoid using automated tools (e.g., bots/scripts).</li>
                  </ul>
                </li>
                <li>
                  <strong>{subbullet} Portal Usage:</strong>
                  <ul>
                    <li>{bullet} Platform to find audit jobs and connect with employers.</li>
                    <li>{bullet} Includes job listings, employer info, and audit career resources.</li>
                  </ul>
                </li>
              </ul>
            </li>

            <li>
              <strong>Account Security</strong>
              <ul>
                <li>{bullet} Maintain confidentiality of login credentials.</li>
                <li>{bullet} Notify BetelJobs of any unauthorized use.</li>
              </ul>
            </li>

            <li>
              <strong>Intellectual Property</strong>
              <ul>
                <li>{bullet} Content is protected by copyright and other IP laws.</li>
                <li>{bullet} No commercial use of content without permission.</li>
              </ul>
            </li>

            <li>
              <strong>Disclaimer of Warranties</strong>
              <ul>
                <li>{bullet} Portal is provided “as is” with no warranties.</li>
                <li>{bullet} BetelJobs doesn’t guarantee accuracy or completeness.</li>
              </ul>
            </li>

            <li>
              <strong>Limitation of Liability</strong>
              <ul>
                <li>{bullet} BetelJobs isn’t liable for damages from using the portal.</li>
              </ul>
            </li>

            <li>
              <strong>Indemnification</strong>
              <ul>
                <li>{bullet} You agree to indemnify BetelJobs for claims resulting from your use.</li>
              </ul>
            </li>

            <li>
              <strong>Modifications</strong>
              <ul>
                <li>{bullet} Terms can change without notice and take effect when posted.</li>
              </ul>
            </li>

            {/* New Refund & Cancellation Policy */}
            <li>
              <strong>Refund & Cancellation Policy</strong>
              <ul>
                <li>{bullet} All payments made on BetelJobs are final, non-cancellable, and non-refundable (No refund policy).</li>
                <li>{bullet} Customers should review all details before making payment.</li>
                <li>{bullet} Refunds may be considered only at the sole discretion of BetelJobs Management.</li>
                <li>{bullet} Decisions regarding refunds are final and binding.</li>
                <li>{bullet} Customers waive the right to dispute or chargeback once payment is processed.</li>
                <li>{bullet} In case of service disruption, BetelJobs may provide alternatives or credits (not guaranteed).</li>
                <li>{bullet} By proceeding with payment, customers agree to this Refund & Cancellation Policy.</li>
              </ul>
            </li>

            <li>
              <strong>Governing Law</strong>
              <ul>
                <li>{bullet} These Terms are governed by Indian law.</li>
              </ul>
            </li>

            <li>
              <strong>Dispute Resolution</strong>
              <ul>
                <li>{bullet} Disputes resolved via e-arbitration by PrivateCourt (Mumbai) after 10 days of discussion.</li>
              </ul>
            </li>

            <li>
              <strong>Severability</strong>
              <ul>
                <li>{bullet} Invalid clauses won’t affect the rest of the Terms.</li>
              </ul>
            </li>

            <li>
              <strong>Contact</strong>
              <ul>
                <li>{bullet} Contact info is available on the portal.</li>
              </ul>
            </li>

            <li>
              <strong>Entire Agreement</strong>
              <ul>
                <li>{bullet} These Terms override previous agreements.</li>
              </ul>
            </li>

            <li>
              <strong>Force Majeure</strong>
              <ul>
                <li>{bullet} BetelJobs isn’t liable for delays due to uncontrollable events.</li>
              </ul>
            </li>

            <li>
              <strong>Waiver</strong>
              <ul>
                <li>{bullet} Waivers must be written and explicit.</li>
              </ul>
            </li>

            <li>
              <strong>Confidentiality</strong>
              <ul>
                <li>{bullet} Maintain confidentiality of shared information.</li>
              </ul>
            </li>

            <li>
              <strong>Content Ownership and Licensing</strong>
              <ul>
                <li>{bullet} You own your content but license it to BetelJobs for platform use.</li>
              </ul>
            </li>

            <li>
              <strong>Termination Clause</strong>
              <ul>
                <li>{bullet} BetelJobs may terminate accounts violating Terms.</li>
              </ul>
            </li>

            <li>
              <strong>Payment Suspension for Breach of Conduct</strong>
              <ul>
                <li>{bullet} BetelJobs can withhold payments for violations or misconduct.</li>
              </ul>
            </li>
          </ol>

          <p className="mt-4" style={{ color: "rgb(71, 77, 106)" }}>
            <em>
              Disclaimer: This information is for general guidance only and does
              not constitute legal advice.
            </em>
            <br />
            <strong>Last modified:</strong> June 18, 2025
          </p>
        </Col>
      </Row>
    </Container>
  );
};

export default TermsAndConditions;
